import { render, staticRenderFns } from "./immuTest.vue?vue&type=template&id=53b3ae16&scoped=true"
import script from "./immuTest.vue?vue&type=script&lang=js"
export * from "./immuTest.vue?vue&type=script&lang=js"
import style0 from "./immuTest.vue?vue&type=style&index=0&id=53b3ae16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b3ae16",
  null
  
)

export default component.exports